import { jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import { QuizImage } from "./quiz-image.js";
import { DesmosGraph } from "./desmos-graph.js";
function QuizMedia({
  image,
  imageMobile,
  desmos,
  vars,
  className,
  alt
}) {
  if (desmos) {
    return /* @__PURE__ */ jsx("div", { "data-quiz-media": true, className: cn("flex justify-center my-4", className), children: /* @__PURE__ */ jsx(DesmosGraph, { state: desmos, vars, className: "rounded-xl" }) });
  }
  if (image) {
    return /* @__PURE__ */ jsx("div", { "data-quiz-media": true, className, children: /* @__PURE__ */ jsx(
      QuizImage,
      {
        image,
        imageMobile,
        alt
      }
    ) });
  }
  return null;
}
export {
  QuizMedia
};
//# sourceMappingURL=quiz-media.js.map
